import { BrandPricesFilter } from "../../filters.js"

export function filterCatalog() {


    BrandPricesFilter();
}

